import React from 'react';
import Edit from 'containers/rest/Edit';
import Form from '../components/Form';

const PlatformsEdit = props => (
  <Edit {...props} resource="platforms">
    <Form />
  </Edit>
);

PlatformsEdit.propTypes = {};

export default PlatformsEdit;
